// test2177
(2177 && 0);
